import { each, filter, find, map, orderBy } from 'lodash';

import axios, { axios as axios_new_api } from '@/store/config';
import { dataLayerPush } from '@/helpers/datalayer';
import dayjs from 'dayjs';

export default {
  // state
  state: {
    auth: {
      token: '',
      timeStamp: '',
    },
    timer: null,

    hasAnyBookableLocations: null,

    //Default to last or present monday
    startDate: dayjs().day(1).format('YYYY-MM-DD'), // 1 == monday

    groupId: null,
    RentalObjectCode: null,
    selectedGroupName: null,

    bookings: [],
    bookingCalender: {},
    bookingCategories: { CategoryList: [] },
  },
  // getters
  getters: {
    hasAnyBookableLocations: (state) => {
      let anyHasLocations = false;

      state.bookingCategories.CategoryList.forEach((category) => {
        if (category && category.Locations && category.Locations.length) anyHasLocations = true;
      });

      return anyHasLocations;
    },
    bookings: (state) => state.bookings,
    bookingCalender: (state) => state.bookingCalender,
    bookingCategories: (state) => state.bookingCategories,

    //Return a usable array of laundry rooms
    bookingableLaundryRooms: (state) => {
      var laundryRooms = [];
      if (state.bookingCategories.CategoryList) {
        state.bookingCategories.CategoryList.forEach((category) => {
          category.Locations.forEach(function (location) {
            location.Groups.forEach(function (group) {
              laundryRooms.push({
                id: group.Id,
                title: location.Name + ' - ' + group.Name,
                value: category.RentalObjectCode,
                label: location.Name + ' - ' + group.Name,
                RentalObjectCode: category.RentalObjectCode,
                lastBookableTimestamp: group.LastBookableTimestamp,
              });
            });
          });
        });

        return laundryRooms;
      }
    },

    bookingsOnSelectedGroup: (state) => {
      if (!state.groupId) return [];

      // Hämtar ut aktuell grupp + locationname
      let GroupWithLocationName;
      each(state.bookingCategories, function (Categories) {
        each(Categories, function (Category) {
          each(Category.Locations, function (Location) {
            each(Location.Groups, function (Group) {
              if (Group.Id === state.groupId) {
                GroupWithLocationName = {
                  id: Group.Id,
                  LocationName: Location.Name,
                  GroupName: Group.Name,
                };
              }
            });
          });
        });
      });

      // Hämtar ut alla bokningar på aktuell grupp, från och med idag
      const bookingsOnGroup = [];
      const today = dayjs().subtract(0, 'day').format('YYYYMMDD');

      each(state.bookings, function (booking) {
        if (
          GroupWithLocationName.LocationName == booking.LocationName &&
          GroupWithLocationName.GroupName == booking.GroupName
        ) {
          bookingsOnGroup.push(booking);
        }
      });

      return bookingsOnGroup;
    },
    selectedGroupName: (state) => {
      if (!state.groupId) return null;

      let GroupWithLocationName;
      each(state.bookingCategories, function (Categories) {
        each(Categories, function (Category) {
          each(Category.Locations, function (Location) {
            each(Location.Groups, function (Group) {
              if (Group.Id === state.groupId) {
                GroupWithLocationName = {
                  id: Group.Id,
                  LocationName: Location.Name,
                  GroupName: Group.Name,
                };
              }
            });
          });
        });
      });

      return GroupWithLocationName.GroupName;
    },

    /**
     * Den valda calenderns aktuella veckans dagar med timeslots.
     */
    selectedCalendarDays: (state) => {
      var days = [];
      // Hämtar ut ett enskilt IntervalPattern på id
      var getIntervalById = function (id) {
        var intervals;
        each(state.bookingCalender.intervalPatterns, function (intervalPattern) {
          if (intervalPattern.id == id) {
            intervals = intervalPattern.intervals;
          }
        });

        return intervals;
      };

      each(state.bookingCalender.days, function (Day) {
        each(Day.dayGroups, function (DayGroup) {
          if (DayGroup.groupId == state.groupId) {
            var intervalsForDay = getIntervalById(DayGroup.intervalPatternId);
            var bookablePassNos = map(DayGroup.bookablePasses, 'no');
            var bookedByCustomerPassNos = map(DayGroup.customerBookings, 'PassNo');

            days.push({
              date: Day.date,
              timeslots: map(intervalsForDay, function (interval) {
                return {
                  // timeslotens date.
                  date: Day.date,

                  // starttid
                  startTime: interval.startTime,

                  // uträknad sluttid
                  endTime: dayjs('20170101T' + interval.startTime.replace(':', '') + '00')
                    .add(interval.LenghtMinutes, 'minutes')
                    .format('HH:mm'),

                  // bokningstidens längd i minuter
                  bookingLength: interval.LenghtMinutes,

                  // får man boka?
                  bookable: bookablePassNos.indexOf(interval.passNo) > -1,

                  // Har jag bokat denna?
                  bookedByMe: bookedByCustomerPassNos.indexOf(interval.passNo) > -1,

                  // Ev. bokningsdetaljer.
                  bookingDetails: (function () {
                    return find(DayGroup.customerBookings, function (booking) {
                      return booking.PassNo == interval.passNo;
                    });
                  })(),
                };
              }),
            });
          }
        });
      });

      return days;
    },

    /**
     * Alla bokningar som är gjorda som börjar idag eller i framtiden
     */
    bookingsFromToday: (state) => {
      const today = dayjs().startOf('day');
      return orderBy(
        filter(state.bookings, (booking) =>
          dayjs(booking.StartTimeStamp).isSameOrAfter(today, 'day')
        ),
        ['StartTimeStamp']
      );
    },


    bookingsLastMonth: (state) => {
      // Hämta senaste kalendermånad
      const startOfLastMonth = dayjs().subtract(0, 'month').startOf('month');
      const endOfLastMonth = dayjs().subtract(0, 'month').endOf('month');
      const today = dayjs().endOf('day').subtract(1, 'day');

      // Filtrera och sortera
      return orderBy(
        filter(state.bookings, (booking) => {
          const bookingDate = dayjs(booking.StartTimeStamp);
          return bookingDate.isBetween(startOfLastMonth, today, 'day', '[]');
        }),
        ['StartTimeStamp']
      );

    },

    /**
     * Närmaste bokning i framtid.
     */
    getClosestBooking: (state, getters) => {
      if (getters.bookingsFromToday && getters.bookingsFromToday.length == 0) return;

      return getters.bookingsFromToday[0];
    },
  },

  // actions
  actions: {
    getBookings({ state, commit, getters }, contractCode) {
      if (!contractCode) return false;
      if (!state.bookingCategories || state?.bookingCategories?.CategoryList.length == 0) return false;
      var _commit = commit;

      let RentalObjectCode = contractCode.trim();
      return new Promise((resolve, reject) => {
        //console.log(RentalObjectCode);

        axios_new_api
          .get('/Applicants/resourcebooking/' + RentalObjectCode + '/bookings')
          .then((response) => {
            //console.log('response.data.CustomerBookingDetails', response.data.CustomerBookingDetails);

            response.data.CustomerBookingDetails.forEach((booking) => {
              const alreadyExists = state.bookings.some(b => b.BookingId === booking.BookingId);
              if (!alreadyExists) {
                _commit('pushBookings', booking);
              }
            });

            resolve(true);
          });
      }).catch((error) => {
        reject(error);
      });
    },

    getBookingCalender({ dispatch, state, commit }) {
      var _commit = commit,
        toDate = dayjs(state.startDate).add(6, 'days').format('YYYY-MM-DD HH:mm');
      return axios_new_api
        .get(
          '/Applicants/resourcebooking/' +
            state.RentalObjectCode +
            '/calendar?dateFrom=' +
            state.startDate +
            '&dateTo=' +
            toDate +
            '&groups=[' +
            state.groupId +
            ']',
        )
        .then(function (response, commit) {
          _commit('setBookingCalender', response.data);
        });
    },

    getBookingCategories({ state, commit, getters }, contractCode) {
      return new Promise((resolve, reject) => {
        if (!contractCode) return false;
        var _commit = commit;

        commit('clearCategories');
        let RentalObjectCode = contractCode.trim();
        axios_new_api
          .get('/Applicants/resourcebooking/me/' + RentalObjectCode + '/categories')
          .then((response) => {
            response.data.CategoryList.forEach((category) => {
              // Lägger på aktuellt RentalObjectCode
              category.RentalObjectCode = RentalObjectCode;
              _commit('pushCategories', category);
            });
            resolve(true);
          })
          .catch((error) => {
            console.log("error", error)
            reject(error);
          });
      });
    },
    setGroupId({ state, commit }, groupId) {
      commit('setGroupId', groupId);
    },

    setRentalObjectCode({ state, commit }, RentalObjectCode) {
      commit('setRentalObjectCode', RentalObjectCode);
    },

    bookLaundry({ dispatch, state, commit }, booking) {
      return new Promise((resolve, reject) => {
        axios_new_api
          .post('/Applicants/resourcebooking/' + state.RentalObjectCode, {
            startTimestamp: booking.startTime,
            lengthMinutes: booking.bookingLength,
            groupId: state.groupId,
          })
          .then(function (response, commit) {
            dataLayerPush({ event: 'bookTvattstuga' });

            // hanterar att det händer att man får OK från APIt men ingen bokninggjorts
            if (
              response.data.BookingId == null &&
              response.data.ObjectName == null &&
              response.data.UnBookable == false
            ) {
              throw Error('tooManyActive');
            } else if (response.data.BookingId == null) throw Error('Boknings id saknas');

            // Hämtar all data igen för att rendera ut senaste ändringarna
            return Promise.all([
              dispatch('getBookings', state.RentalObjectCode),
              dispatch('getBookingCalender'),
            ]).then(() => {
              resolve();
            });
          })
          .catch(function (error) {
            reject(error);
          });
      });
    },

    cancelBooking({ dispatch, state, commit }, id) {
      var _commit = commit;

      return new Promise((resolve, reject) => {
        axios_new_api
          .delete('/Applicants/resourcebooking/' + state.RentalObjectCode + '/' + id)
          .then(function (response, commit) {
            dataLayerPush({ event: 'cancelTvattstuga' });
            state.bookings = state.bookings.filter(b => b.BookingId !== id);

            // Hämtar all data igen för att rendera ut senaste ändringarna
            Promise.all([
              dispatch('getBookings', state.RentalObjectCode),
              dispatch('getBookingCalender'),
            ]).then(() => {
              resolve();
            });
          })
          .catch(function (error) {
            return reject(error);
          });
      });
    },

    increaseWeek({ dispatch, state, commit }) {
      var newStartDate = dayjs(state.startDate).add(7, 'days').format('YYYY-MM-DD');
      commit('setStartDate', newStartDate);
      return dispatch('getBookingCalender');
    },

    decreaseWeek({ dispatch, state, commit }) {
      var newStartDate = dayjs(state.startDate).subtract(7, 'days').format('YYYY-MM-DD');
      commit('setStartDate', newStartDate);
      return dispatch('getBookingCalender');
    },
  },

  // mutations
  mutations: {
    setToken(state, data) {
      state.auth = {
        token: data.response.Token,
        timeStamp: data.dt,
      };
    },
    setGroupId(state, id) {
      state.groupId = id;
    },
    setGroupName(state, groupname) {
      state.groupName = groupname;
    },
    setRentalObjectCode(state, RentalObjectCode) {
      state.RentalObjectCode = RentalObjectCode;
    },
    pushBookings(state, booking) {
      state.bookings.push(booking);
    },
    clearBookings(state) {
      state.bookings.splice(0, state.bookings.length);
    },
    setBookingCalender(state, response) {
      state.bookingCalender = response;
    },
    pushCategories(state, category) {
      // set initial values
      if (!state.groupId) {
        state.groupId = category.Locations[0].Groups[0].Id;
        state.RentalObjectCode = category.RentalObjectCode;
      }
      category.Locations.forEach((loc) => {
        loc.Groups.forEach((grp) => {
          grp.Name = grp.Name;
        });
      });
      state.bookingCategories.CategoryList.push(category);
    },
    clearCategories(state) {
      state.bookingCategories.CategoryList.splice(0, state.bookingCategories.CategoryList.length);
    },

    setStartDate(state, date) {
      state.startDate = date;
    },
    saveBooking(state, booking) {},
  },
};
